import { preloadPostOfficeScreenSpaceFlags } from '@atlassian/confluence-post-office-provider/entry-points/screen-space-flags-placement';

import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures';
import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';

export async function preloadScreenSpaceFlags(match: RouteMatch | null) {
	const preloadedSessionContext = getPreloaderFnContext();
	const { userId } = preloadedSessionContext;
	if (!userId || !match) {
		return;
	}

	return SSRMeasures.run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async () => {
		return preloadPostOfficeScreenSpaceFlags(preloadedSessionContext, match);
	});
}
